import React from "react";
import Input from "../../../../Input";
import Dropdown from "../../../../Dropdown";
import pixabayLogo from "../../../../../assets/images/pixabay.svg";
import giphyLogo from "../../../../../assets/images/giphy.svg";
import { IconButton } from "@mui/material";
import { Search } from "@mui/icons-material";

function Header({
  selectedEngine,
  handleEngineChange,
  items,
  mediaKeyword,
  handleChangeMediaKeyword,
  fieldPlaceHolder = "Search Media or select a category",
  showIcon = true,
  iconPosition = "start",
  showDropdown = false,
  onSearch,
  mediaType,
}) {
  // Determine which logo to show. Use the engine value (1 => Images) and
  // fall back to inspecting the selected item's title.
  const selectedItem =
    items &&
    items.find((it) => String(it.value ?? it.key) === String(selectedEngine));
  const engineValue = String(selectedEngine);
  const isImagesSelected =
    engineValue === "1" ||
    (selectedItem &&
      String(selectedItem.title ?? "")
        .toLowerCase()
        .includes("image"));
  const canNavigateToPixabay =
    isImagesSelected && mediaKeyword && mediaKeyword.trim().length > 2;
  return (
    <div>
      <div
        style={{ display: "flex", justifyContent: "start", marginBottom: 8 }}
      >
        <img
          src={isImagesSelected ? pixabayLogo : giphyLogo}
          alt={isImagesSelected ? "pixabay" : "giphy"}
          style={{
            height: 32,
            width: 88,
            cursor: canNavigateToPixabay ? "pointer" : "default",
          }}
          title={canNavigateToPixabay ? "Search on Pixabay" : undefined}
          onClick={() => {
            if (canNavigateToPixabay) {
              const q = encodeURIComponent(mediaKeyword.trim());
              const basePath = mediaType === "video" ? "videos" : "images";
              window.open(
                `https://pixabay.com/${basePath}/search/${q}/`,
                "_blank"
              );
            }
          }}
        />
      </div>
      <div
        style={{
          position: "sticky",
          display: "flex",
          width: "100%",
          gap: 10,
        }}
      >
        {showDropdown && (
          <div style={{ flex: "0 0 25%" }}>
            <Dropdown
              variant="outlined"
              options={[
                { value: 1, label: "Images" },
                { value: 2, label: "Gifs" },
              ]}
              selectedValue={selectedEngine}
              onChange={(e) => handleEngineChange(e.target.value)}
            />
          </div>
        )}

        <div style={{ flex: showDropdown ? "0 0 55%" : "0 0 85%" }}>
          <Input
            isSearch={true}
            placeholder={fieldPlaceHolder}
            variant={"secondary"}
            value={mediaKeyword}
            onChange={(e) => handleChangeMediaKeyword(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                onSearch && onSearch();
              }
            }}
            onClear={() => handleChangeMediaKeyword("")}
            showClearIcon={mediaKeyword.length !== 0}
          />
        </div>

        <div
          style={{
            flex: "0 0 15%",
            display: "flex",
          }}
        >
          <IconButton
            onClick={onSearch}
            aria-label="search"
            style={{
              width: 40,
              height: 35,
              marginTop: 5,
              borderRadius: 4,
              background: "var(--Primary-Purple-500, #9B5AF8)",
              opacity: 1,
              color: "white",
            }}
          >
            <Search fontSize="small" />
          </IconButton>
        </div>
      </div>
    </div>
  );
}

export default Header;
